import { audiIcon, timeIcon, userIcon } from "./icons";
export const templateLiveRadioCard = (data) => {
  const defaultImage =
    typeof tdea_ajax !== "undefined" && tdea_ajax.theme_url
      ? `${tdea_ajax.theme_url}assets/logo-tdea-radio.svg`
      : `${window.location.origin}/wp-content/themes/TdeA/assets/logo-tdea-radio.svg`;

  const imageUrl = data.imagen_url || defaultImage;
  const imageClass = !data.imagen_url ? "live-card__figure--default" : "";

  return `
          <li class="live-card">
            <figure class="live-card__figure ${imageClass}">
              <img src="${imageUrl}" alt="${data.titulo}">
            </figure>
            <div class="live-card__content">
              <h2 class="h3 live-card__title">${data.titulo}</h2>
              <p class="live-card__description">${
                data.introduccion_corta ||
                "Escucha nuestra programación en vivo"
              }</p>
              <ul class="live-card__list">
                <li class="live-card__list--item">
                  <i>
                 ${timeIcon()}
                  </i>
                  <span class="live-card__list--span">${
                    data.presentador || "Invitado Especial"
                  }</span>
                </li>
                <li class="live-card__list--item">
                  <i>
                   ${userIcon()}
                  </i>
                  <span class="live-card__list--span">${
                    data.duracion || "60 min"
                  }</span>
                </li>
              </ul>
              <button class="live-card__button tdea-button-radio tdea-button-radio--green">
                <i class="icon-play">${audiIcon()}</i> Escuchar en Vivo
              </button>
            </div>
          </li>
        `;
};

export const templateNextRadioCard = (data, time, title = "A continuación") => {
  return `
     <div class="next-programs-card">
                <header class="next-programs-card__header">
                    <h3 class="h4 next-programs-card__title">${title}</h3>
                    <span class="tag next-programs-card__tag">${data.tag}</span>
                </header>
                <div class="next-programs-card__content">
                    <h4 class="h5 next-programs-card__content--title">${
                      data.titulo
                    }</h4>
                    <p class="next-programs-card__content--description">${
                      data.introduccion_corta
                    }</p>
                    <ul class="next-programs-card__list">
                      <li class="next-programs-card__list--item">
                            <span class="next-programs-card__list--span">${
                              data.presentador
                            }</span>
                        </li>
                        <li class="next-programs-card__list--item">
                            <i>
                                ${timeIcon()}
                            </i>
                            <span class="next-programs-card__list--span">${
                              time.inicio
                            } - ${time.fin}</span>
                        </li>
                      
                    </ul>
                </div>
            </div>
    `;
};
